<template>
    <div class="banner-teaser" :class="'banner-teaser--' + type">
        <a href="https://go.puma.com/svobs-ci" target="_blank" class="banner-teaser__inner" :style="'background-image:url(' + banner_bg + ');'" @click.prevent="outboundLinkClicked('https://go.puma.com/svobs-ci')">
            <div class="banner-teaser__content">
            
                <div class="banner-teaser__text">
                    <span class="h3" v-translate>banner_ad_title</span>
                    <span class="text" v-translate>banner_ad_text</span>
                    <puma-button class="banner-teaser__button" :small="true" :type="type" v-translate><translate>banner_ad_button</translate></puma-button>
                </div>

            </div>
        </a>
    </div>
</template>

<script>
import banner_bg from "../assets/img/banner.jpg"
import { captureOutboundLink } from '@/utils/tracking';

export default {
    name: "BannerAd",
    data() {
        return {
            banner_bg: banner_bg
        }
    },
    props: {
        type: String
    },
    methods: {
        outboundLinkClicked(url) {
            captureOutboundLink(url, {navigation: {subSection: "home", screenName: "opportunities"}, event: {type: "outbound", value: "web_shop_now_ecom"}})
            return false
        }
    }
}
</script>

<style lang="scss" scoped>
.banner-teaser {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 0 6px;

    @include mq(tablet-landscape){
        color: black !important;
    }

    &__inner {
        height: 100%;
        position: relative;
        background-size: cover;
        background-position: center center;
        display: block;

        &:after {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            opacity: 0.5;
            mix-blend-mode: multiply;
            background: linear-gradient(275deg, rgba(0,0,0,1) 0%, rgba(0,0,0,0) 65%);

            @include mq($until: tablet) {
                background: black;
            }
        }
    }
    &__content {
        position: relative;
        z-index: 3;
        height: 100%;
        width: 100%;
        padding: 30px 30px 70px;
        display: flex;
        align-items: center;
        justify-content: flex-end;

        @include mq($until: tablet) {
            padding: 20px 20px 40px;
        }
    }

    &__button {
        margin-top: 12px;
    }
    &__text {
        text-align: right;

        .h3,
        .text {
            display: block;

            &:first-child {
                margin-bottom: 2px;
            }
            &:last-child {
                text-transform: none;
            }
        }
    }

    &--light {
        .banner-teaser {
            &__text {
                .text,
                .h3 {
                    color: $puma-color-white;
                }
            }
        }
    }
}
</style>